export const monitoringRoutes = [
  {
    path: 'monitoring',
    children: [
      {
        path: 'inbox',
        loadChildren: () => import('@rma/monitoring/inbox'),
      },
      {
        path: 'leaderboards',
        loadChildren: () => import('@rma/monitoring/leaderboards'),
      },
      {
        path: 'online-performance',
        loadChildren: () => import('@rma/reporting/roi-insights'),
      },
    ],
  },
];
